module.exports = __webpack_public_path__ + "static/images/apple-gift-con-bg02.8cfcf73.png";